import {IBaseResponse, WebService} from '.';
import {CustomerProfileStore, SessionStore} from '../store';
import {Route} from 'vue-router';

export interface PageViewPayload {
	pageName: string;
}

class Tracking {
	EVENT_TYPE_PAGE_VIEW = 'page_view';
	EVENT_TYPE_APP_OPEN = 'app_open';
	EVENT_TYPE_APP_CLOSE = 'app_close';
	EVENT_TYPE_API_CALL = 'api_call';


	async trackEvent(event: string, payload: Record<string, any> = {}) {
		try {
			// If we have a tracking client, use that, else fallback to old method
			if(
				CustomerProfileStore.trackingClient
			) {
				await CustomerProfileStore.trackingClient.post<IBaseResponse<{message: string}>>(event, payload);
			} else if(SessionStore.authConfig === null) {
				await WebService.baseStarted;
				await WebService.unauthenticatedClient.post<IBaseResponse<{message: string}>>(`events/${event}`, payload);
			} else {
				await WebService.loggedInStarted;
				await WebService.authenticatedClient.post<IBaseResponse<{message: string}>>(`events/${event}`, payload);
			}
		} catch(error) {
			// Removed the sentry reporting for this error due to
			// excessive reporting of this error, it's not reliable
			// (if the app is closed it will kill this request and throw an error)
			// Only even show the error in dev
			if(process.env.NODE_ENV === 'development') {
				console.error(error);
			}
		}
	}

	trackPageView(route: Route) {
		this.trackEvent(this.EVENT_TYPE_PAGE_VIEW, {
			path: route.path,
			name: route.name,
			query: route.query,
			params: route.params,
			fullPath: route.fullPath,
			meta: route.meta
		});
	}
}



export const TrackingService = new Tracking();
